export enum Phrases {
  PREMIUM_BENEFITS_TITLE_1 = 'What’s Premium?',
  PREMIUM_BENEFITS_TITLE_2 = 'Why Premium?',
  PREMIUM_BENEFITS_TITLE_3 = 'Unlock <0>Premium</0> power',
  PREMIUM_BENEFITS_CTA_LABEL = 'Go Premium',
  PREMIUM_BENEFITS_CTA_LABEL_2 = 'Keep Premium',
  RATING = 'Customers love us <0></0> <1>Trustpilot</1> | <2>4.5</2>',

  POPUP_GEN_ONE_PREMIUM_AI_RESPONSE_TITLE = 'Generating <0>Premium</0> AI response',
  POPUP_GEN_ONE_PREMIUM_AI_RESPONSE_SUBTITLE = '<0>1 Premium answer</0> • Then Free Mode',
  POPUP_PREMIUM_ANSWER_USED_TITLE = 'Your <0>Premium</0> answer is used',
  POPUP_PREMIUM_ANSWER_USED_SUBTITLE = 'Next answers will be Basic on the Free Plan. Stay on Premium for A+ results.',
  POPUP_GEN_FREE_AI_RESPONSE_TITLE = 'Generating AI response in Free plan',
  POPUP_GEN_FREE_AI_RESPONSE_SUBTITLE = 'Why do I see a snail?',
  POPUP_GEN_PREMIUM_AI_RESPONSE_TITLE = 'Generating <0>Premium</0> AI response',

  SKIP_FOR_NOW_BUTTON_LABEL = 'Skip for now',
  CIRCULAR_TIMER_LABEL = 'remains...',

  REMOVE_ADS_TITLE = 'Go <0>Premium</0> to remove ads',
  REMOVE_ADS_BUTTON_LABEL = 'Go Premium',
  REMOVE_ADS_BUTTON_LABEL_2 = 'Remove ads',
  REMOVE_ADS_BENEFIT_1 = '2x faster',
  REMOVE_ADS_BENEFIT_2 = 'A+ solutions',
  REMOVE_ADS_BENEFIT_3 = 'No ads',
  ADVERTISEMENT_TITLE = 'Advertisement',

  TOOLTIP_PREMIUM_PLAN_TITLE = 'The A+ solution created by <0>Premium</0> for you.',
  TOOLTIP_PREMIUM_PLAN_SUBTITLE = 'A+ solution uses advanced AI models trained on expert-written works to improve accuracy, structure, and clarity of your original answer.',

  TOOLTIP_FREE_PLAN_TITLE = 'Your plan switched to Free',
  TOOLTIP_FREE_PLAN_SUBTITLE = 'This and the following answers will be basic. Keep Premium for A+ results.',
  TOOLTIP_FREE_PLAN_TITLE_2 = 'Your current plan is Free',
  TOOLTIP_FREE_PLAN_SUBTITLE_2 = 'It’s a snail because we’re using a slower model within the Free plan.',
  TOOLTIP_FREE_PLAN_CTA_LABEL = 'Keep Premium',
  TOOLTIP_FREE_PLAN_CTA_LABEL_2 = 'Go Premium',
  TOOLTIP_FREE_PLAN_SKIP_BUTTON_LABEL = 'Skip',

  AI_INPUT_PLACEHOLDER = `Type a change or pick a tag`,

  COPY_BUTTON_LABEL = 'Copy text',
  DOWNLOAD_BUTTON_LABEL = 'Download your essay',

  TOAST_CLOSE_BUTTON_LABEL = 'Close toast',
  CLOSE_BUTTON_LABEL = 'Close',

  LOADER_LABEL = 'Loading...',
  LOADER_EDITOR_TITLE_1 = 'Analyzing your task and instructions',
  LOADER_EDITOR_TITLE_2 = 'Picking the best AI for your subject and grade',
  LOADER_EDITOR_TITLE_3 = 'Learning from millions of similar A+ assignments',
  LOADER_EDITOR_TITLE_4 = 'Tailoring the answer to your style and format',
  LOADER_EDITOR_TITLE_5 = 'Checking for AI and plagiarism risks',
  LOADER_EDITOR_TITLE_6 = 'Delivering a clean, ready-to-submit answer',
  LOADER_EDITOR_LABEL = 'It takes about 30 seconds',

  TOAST_TEXT_GENERATED = 'Generation was successful',

  TEXT_COPIED_TO_CLIPBOARD = 'Text copied to clipboard',

  PAGE_TITLE_AI_HOMEWORK_SOLVER = 'AI Homework Solver - Getsolved.ai',

  SUBSCRIPTION_STATUS_FREE = 'FREE',
  SUBSCRIPTION_STATUS_PREMIUM = 'PREMIUM',

  YOUR_SOLUTION_TITLE = 'Your Solution',
  NEW_QUESTION_BUTTON_LABEL = 'New question',

  PREMIUM_ANSWER_PLACEHOLDER_TITLE = 'Step-By-Step Explanation of Probability of Confidence Among Students',
  PREMIUM_ANSWER_PLACEHOLDER_UNLOCK_BUTTON_LABEL = 'Unlock A+ Result',

  PREMIUM_ANSWER_PLACEHOLDER_TEXT_1 = "You're currently viewing a placeholder of a premium answer. With full access, you'll unlock detailed explanations, clear reasoning, and structured solutions designed to help you learn faster and more effectively.",
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_2 = "What You're Missing",
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_3 = 'Premium answers provide step-by-step breakdowns, examples, and insights that go beyond basic responses. Instead of short summaries, you get complete guidance that helps you understand *how* the solution works — not just the final result.',
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_4 = 'Included With Subscription',
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_5 = '- Full unrestricted solutions',
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_6 = '- Clear explanations tailored for learning',
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_7 = '- Faster responses and premium content access',
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_8 = 'Upgrade to Continue',
  PREMIUM_ANSWER_PLACEHOLDER_TEXT_9 = 'Unlock the rest of this answer and thousands more with a premium subscription. Get instant access and continue your learning without limitations.',

  APP_ERROR_TITLE = 'We’re experiencing technical issues. Please try again!',
  APP_ERROR_DESCRIPTION = 'Please reload the page',
  APP_ERROR_RELOAD_BUTTON = 'Reload',

  // Subject Group Input Tags
  // Mathematics & Statistics
  INPUT_TAG_SIMPLIFY_EXPLANATION_MATH = 'Simplify explanation',
  INPUT_TAG_FOCUS_ON_KEY_STEPS_MATH = 'Focus on key steps',
  INPUT_TAG_REDERIVE_THE_RESULT = 'Re-derive the result',
  INPUT_TAG_ALTERNATIVE_METHOD = 'Alternative method',
  INPUT_TAG_VALIDATE_AGAINST_THE_QUESTION = 'Validate against the question',
  INPUT_TAG_EXAM_STYLE_CONCISE_ANSWER_MATH = 'Exam-style concise answer',
  // Computer Science & Tech
  INPUT_TAG_EXPLAIN_THE_LOGIC_SIMPLER = 'Explain the logic simpler',
  INPUT_TAG_FOCUS_ON_THE_CORE_ALGORITHM = 'Focus on the core algorithm',
  INPUT_TAG_ALTERNATIVE_APPROACH = 'Alternative approach',
  INPUT_TAG_RECHECK_EDGE_CASES = 'Re-check edge cases',
  INPUT_TAG_SHORTER_EXPLANATION = 'Shorter explanation',
  // Natural Sciences
  INPUT_TAG_SIMPLIFY_EXPLANATION_NATURAL_SCIENCES = 'Simplify explanation',
  INPUT_TAG_ADD_DEFINITIONS = 'Add definitions',
  INPUT_TAG_ADD_EXAMPLES_NATURAL_SCIENCES = 'Add examples',
  INPUT_TAG_COMPARE_WITH_A_SIMILAR_CONCEPT = 'Compare with a similar concept',
  INPUT_TAG_FOCUS_ON_KEY_MECHANISM = 'Focus on key mechanism',
  // Engineering & Architecture
  INPUT_TAG_CLARIFY_ASSUMPTIONS = 'Clarify assumptions',
  INPUT_TAG_FOCUS_ON_CALCULATIONS = 'Focus on calculations',
  INPUT_TAG_EXPLAIN_DESIGN_LOGIC = 'Explain design logic',
  INPUT_TAG_ALTERNATIVE_DESIGN_APPROACH = 'Alternative design approach',
  INPUT_TAG_CONCISE_ENGINEERING_ANSWER = 'Concise engineering answer',
  // Business & Management
  INPUT_TAG_IMPROVE_STRUCTURE_BUSINESS = 'Improve structure',
  INPUT_TAG_MAKE_IT_MORE_PROFESSIONAL = 'Make it more professional',
  INPUT_TAG_FOCUS_ON_RECOMMENDATIONS = 'Focus on recommendations',
  INPUT_TAG_SHORT_EXECUTIVE_STYLE_ANSWER = 'Short executive-style answer',
  INPUT_TAG_ADD_PRACTICAL_EXAMPLE = 'Add practical example',
  // Economics & Finance
  INPUT_TAG_CLARIFY_ECONOMIC_INTUITION_ECONOMICS = 'Clarify economic intuition',
  INPUT_TAG_FOCUS_ON_KEY_STEPS_ECONOMICS = 'Focus on key steps',
  INPUT_TAG_VALIDATE_CALCULATIONS_ECONOMICS = 'Validate calculations',
  INPUT_TAG_ALTERNATIVE_INTERPRETATION_ECONOMICS = 'Alternative interpretation',
  INPUT_TAG_EXAM_STYLE_CONCISE_ANSWER_ECONOMICS = 'Exam-style concise answer',
  // Economics & Finance (Accounting)
  INPUT_TAG_CLARIFY_ECONOMIC_INTUITION_ACCOUNTING = 'Clarify economic intuition',
  INPUT_TAG_FOCUS_ON_KEY_STEPS_ACCOUNTING = 'Focus on key steps',
  INPUT_TAG_VALIDATE_CALCULATIONS_ACCOUNTING = 'Validate calculations',
  INPUT_TAG_ALTERNATIVE_INTERPRETATION_ACCOUNTING = 'Alternative interpretation',
  INPUT_TAG_EXAM_STYLE_CONCISE_ANSWER_ACCOUNTING = 'Exam-style concise answer',
  // Social Sciences & Law
  INPUT_TAG_IMPROVE_LOGICAL_FLOW = 'Improve logical flow',
  INPUT_TAG_CLARIFY_MAIN_ARGUMENT = 'Clarify main argument',
  INPUT_TAG_ADD_COUNTERPOINT_EXPLANATION = 'Add counterpoint explanation',
  INPUT_TAG_FOCUS_ON_THEORY_APPLICATION = 'Focus on theory application',
  INPUT_TAG_SHORT_ANALYTICAL_SUMMARY = 'Short analytical summary',
  // Health & Nursing
  INPUT_TAG_CLARIFY_CARE_PRIORITIES = 'Clarify care priorities',
  INPUT_TAG_SIMPLIFY_MEDICAL_LANGUAGE = 'Simplify medical language',
  INPUT_TAG_FOCUS_ON_ASSESSMENT_STEPS = 'Focus on assessment steps',
  INPUT_TAG_CONCISE_EXAM_STYLE_ANSWER_HEALTH = 'Concise exam-style answer',
  // Humanities & Languages
  INPUT_TAG_IMPROVE_STRUCTURE_HUMANITIES = 'Improve structure',
  INPUT_TAG_CLARIFY_THESIS = 'Clarify thesis',
  INPUT_TAG_MAKE_IT_MORE_FORMAL = 'Make it more formal',
  INPUT_TAG_ADD_EXAMPLES_HUMANITIES = 'Add examples',
  INPUT_TAG_SHORTER_ANALYTICAL_VERSION = 'Shorter analytical version',
  // Other
  INPUT_TAG_SIMPLIFY_EXPLANATION_OTHER = 'Simplify explanation',
  INPUT_TAG_ADD_EXAMPLES_OTHER = 'Add examples',
  INPUT_TAG_FOCUS_ON_KEY_IDEA = 'Focus on key idea',
  INPUT_TAG_SHORT_SUMMARY = 'Short summary',

  // Subject Group Feature Banner Phrases
  // Mathematics & Statistics
  FEATURE_BANNER_MATH_TEXT = 'Turn this solution into exam-ready practice materials',
  FEATURE_BANNER_MATH_CTA = 'study tools',
  // Computer Science & Tech
  FEATURE_BANNER_COMPUTER_SCIENCE_TEXT = 'Turn this answer into real, test-ready code',
  FEATURE_BANNER_COMPUTER_SCIENCE_CTA = 'coding tools',
  // Natural Sciences
  FEATURE_BANNER_NATURAL_SCIENCES_TEXT = 'Convert this answer into study-ready materials',
  FEATURE_BANNER_NATURAL_SCIENCES_CTA = 'flashcards & summaries',
  // Engineering & Architecture
  FEATURE_BANNER_ENGINEERING_TEXT = 'Turn this solution into an engineering workflow',
  FEATURE_BANNER_ENGINEERING_CTA = 'diagrams & checks',
  // Business & Management
  FEATURE_BANNER_BUSINESS_TEXT = 'Turn this answer into a business-ready deliverable',
  FEATURE_BANNER_BUSINESS_CTA = 'business tools',
  // Economics & Finance
  FEATURE_BANNER_ECONOMICS_TEXT = 'Transform this into exam & practice materials',
  FEATURE_BANNER_ECONOMICS_CTA = 'finance tools',
  // Economics & Finance (Accounting)
  FEATURE_BANNER_ACCOUNTING_TEXT = 'Transform this into exam & practice materials',
  FEATURE_BANNER_ACCOUNTING_CTA = 'finance tools',
  // Social Sciences & Law
  FEATURE_BANNER_SOCIAL_SCIENCES_TEXT = 'Turn this into a strong academic argument',
  FEATURE_BANNER_SOCIAL_SCIENCES_CTA = 'analysis tools',
  // Health & Nursing
  FEATURE_BANNER_HEALTH_TEXT = 'Convert this answer into clinical study tools',
  FEATURE_BANNER_HEALTH_CTA = 'nursing resources',
  // Humanities & Languages
  FEATURE_BANNER_HUMANITIES_TEXT = 'Turn this answer into a polished academic piece',
  FEATURE_BANNER_HUMANITIES_CTA = 'writing tools',
  // Other
  FEATURE_BANNER_OTHER_TEXT = 'Turn this answer into study-ready materials',
  FEATURE_BANNER_OTHER_CTA = 'extra tools',

  // Subject Group Solution Tools Names
  // Mathematics & Statistics
  SOLUTION_TOOL_GENERATE_PRACTICE_PROBLEMS = 'Generate practice problems',
  SOLUTION_TOOL_MAKE_A_GRAPH_PLOT = 'Make a graph / plot',
  SOLUTION_TOOL_CREATE_A_CALCULATION_TABLE = 'Create a calculation table',
  SOLUTION_TOOL_FORMULA_CHEAT_SHEET_MATH = 'Formula cheat sheet',
  SOLUTION_TOOL_QUIZ_ME_MATH = 'Quiz me',
  // Computer Science & Tech
  SOLUTION_TOOL_GENERATE_RUNNABLE_CODE = 'Generate runnable code',
  SOLUTION_TOOL_ADD_TEST_CASES = 'Add test cases',
  SOLUTION_TOOL_EXPLAIN_TIME_SPACE_COMPLEXITY = 'Explain time & space complexity',
  SOLUTION_TOOL_DEBUG_THIS_LOGIC = 'Debug this logic',
  SOLUTION_TOOL_REFACTOR_FOR_CLARITY = 'Refactor for clarity',
  // Natural Sciences
  SOLUTION_TOOL_GENERATE_FLASHCARDS = 'Generate flashcards',
  SOLUTION_TOOL_CREATE_SUMMARY_NOTES_NATURAL_SCIENCES = 'Create summary notes',
  SOLUTION_TOOL_KEY_TERMS_CHEAT_SHEET = 'Key terms cheat sheet',
  SOLUTION_TOOL_QUIZ_ME_NATURAL_SCIENCES = 'Quiz me',
  SOLUTION_TOOL_PRACTICE_QUESTIONS_NATURAL_SCIENCES = 'Practice questions',
  // Engineering & Architecture
  SOLUTION_TOOL_CREATE_A_DIAGRAM = 'Create a diagram',
  SOLUTION_TOOL_ENGINEERING_CHECKLIST = 'Engineering checklist',
  SOLUTION_TOOL_DESIGN_VERIFICATION_STEPS = 'Design verification steps',
  SOLUTION_TOOL_UNITS_CONSTRAINTS_CHECKLIST = 'Units & constraints checklist',
  SOLUTION_TOOL_PRACTICE_ENGINEERING_PROBLEMS = 'Practice engineering problems',
  // Business & Management
  SOLUTION_TOOL_EXECUTIVE_SUMMARY = 'Executive summary',
  SOLUTION_TOOL_SWOT_PESTLE_ANALYSIS = 'SWOT / PESTLE analysis',
  SOLUTION_TOOL_ACTION_PLAN = 'Action plan',
  SOLUTION_TOOL_COMPARISON_TABLE = 'Comparison table',
  SOLUTION_TOOL_PRESENTATION_OUTLINE = 'Presentation outline',
  // Economics & Finance
  SOLUTION_TOOL_PRACTICE_EXAM_QUESTIONS_ECONOMICS = 'Practice exam questions',
  SOLUTION_TOOL_CALCULATION_TEMPLATES_ECONOMICS = 'Calculation templates',
  SOLUTION_TOOL_FORMULA_CHEAT_SHEET_ECONOMICS = 'Formula cheat sheet',
  SOLUTION_TOOL_GRAPH_TRENDS_SUPPLY_DEMAND_ECONOMICS = 'Graph trends / supply & demand',
  // Economics & Finance (Accounting)
  SOLUTION_TOOL_PRACTICE_EXAM_QUESTIONS_ACCOUNTING = 'Practice exam questions',
  SOLUTION_TOOL_CALCULATION_TEMPLATES_ACCOUNTING = 'Calculation templates',
  SOLUTION_TOOL_FORMULA_CHEAT_SHEET_ACCOUNTING = 'Formula cheat sheet',
  SOLUTION_TOOL_GRAPH_TRENDS_SUPPLY_DEMAND_ACCOUNTING = 'Graph trends / supply & demand',
  SOLUTION_TOOL_JOURNAL_ENTRY_TEMPLATES = 'Journal entry templates',
  SOLUTION_TOOL_T_ACCOUNTS_BUILDER = 'T-accounts builder',
  SOLUTION_TOOL_FINANCIAL_STATEMENTS_FORMAT = 'Financial statements format',
  // Social Sciences & Law
  SOLUTION_TOOL_IRAC_TEMPLATE_LAW = 'IRAC template (law)',
  SOLUTION_TOOL_ARGUMENT_OUTLINE = 'Argument outline',
  SOLUTION_TOOL_COUNTERARGUMENTS_BUILDER = 'Counterarguments builder',
  SOLUTION_TOOL_CASE_STYLE_PRACTICE_QUESTIONS = 'Case-style practice questions',
  SOLUTION_TOOL_STUDY_NOTES_SOCIAL_SCIENCES = 'Study notes',
  // Health & Nursing
  SOLUTION_TOOL_CARE_PLAN_TEMPLATE = 'Care plan template',
  SOLUTION_TOOL_ASSESSMENT_CHECKLIST = 'Assessment checklist',
  SOLUTION_TOOL_PATIENT_EDUCATION_SCRIPT = 'Patient education script',
  SOLUTION_TOOL_NCLEX_STYLE_QUESTIONS = 'NCLEX-style questions',
  SOLUTION_TOOL_STUDY_NOTES_HEALTH = 'Study notes',
  // Humanities & Languages
  SOLUTION_TOOL_ESSAY_OUTLINE = 'Essay outline',
  SOLUTION_TOOL_THESIS_BUILDER = 'Thesis builder',
  SOLUTION_TOOL_EVIDENCE_EXAMPLES_BANK = 'Evidence & examples bank',
  SOLUTION_TOOL_ADD_CITATIONS = 'Add citations',
  SOLUTION_TOOL_PRACTICE_ESSAY_QUESTIONS = 'Practice essay questions',
  // Other
  SOLUTION_TOOL_SUMMARY_NOTES_OTHER = 'Summary notes',
  SOLUTION_TOOL_QUIZ_ME_OTHER = 'Quiz me',
  SOLUTION_TOOL_PRACTICE_QUESTIONS_OTHER = 'Practice questions',
}

export enum ErrorPhrase {
  NO_USER_ID = 'User is not registered',
  NO_AVAILABLE_PAGES = 'Oh, it seems you worked hard and used all your credit; please update your subscription in {account_link}',
  DEFAULT_ERROR = 'We’re experiencing technical issues. Please try again.',
  NO_TEXT_TO_GENERATE = 'No text to generate',
}
